import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { findIndex, equals } from "ramda";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { teal } from "@material-ui/core/colors";
import { getActiveStep } from "common/selectors";
import * as steps from "common/steps";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxHeight: 100,
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    flexGrow: 1,
  },

  step: {
    flexGrow: 1,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },

  stepIndex: {
    fontSize: "x-small",
  },

  stepLabel: {
    "& $label": {
      color: theme.palette.primary.main,
    },

    "& $active": {
      color: theme.palette.primary.dark,
      fontWeight: "bold",
    },
    "& $completed": {
      color: teal[500],
    },
  },

  active: {},
  label: {},

  completed: {
    background: teal[100],
  },
}));

//
// const mapStepMenuDispatch = step => dispatch => ({
//   onClick: () => dispatch({ type: SET_ACTIVE_STEP, step }),
// });
//

const SubmissionPanelMenu = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const activeStep = useSelector(getActiveStep);
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const activeStepIdx = findIndex(equals(activeStep), steps.list);
    setStepIndex(activeStepIdx < 0 ? 0 : activeStepIdx - 1);
  }, [activeStep]);

  console.log(`activeStep : ${activeStep}`);
  console.log(`activeStepIdx : ${stepIndex}`);

  return (
    <div className={classes.root}>
      <Stepper connector={null} activeStep={stepIndex}>
        {steps.labels.map((label, index) => {
          return (
            <Step
              classes={{ root: classes.step, completed: classes.completed }}
              key={label}
            >
              <StepLabel
                icon={null}
                classes={{
                  root: classes.stepLabel,
                  active: classes.active,
                  completed: classes.completed,
                  label: classes.label,
                }}
              >
                <div className={classes.stepIndex}>
                  {t("step_bar_number", "STEP 0") + (index + 1)}
                </div>
                <div>{t(label)}</div>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default SubmissionPanelMenu;
